        // Brand configurations
        const brandConfigs = {
            'injoy-hearing': {
                name: 'Injoy Hearing',
                primaryColor: '#085e88',
                secondaryColor: '#61d0ee',
                accentColor: '#fe5f00',
                textColor: '#2d3748',
                grayLight: '#f7fafc',
                grayMedium: '#e2e8f0',
                grayDark: '#718096',
                shopUrl: 'https://injoyhearing.com/shop/',
                logoPath: '/attached_assets/cropped-Injoy-Logo (1)_1758130721041.png'
            },
            'direct-hearing': {
                name: 'Direct Hearing',
                primaryColor: '#0171BC',
                secondaryColor: '#333333',
                accentColor: '#fe5f00',
                textColor: '#2d3748',
                grayLight: '#f7fafc',
                grayMedium: '#e2e8f0',
                grayDark: '#718096',
                shopUrl: 'https://directhearing.com/shop/',
                logoPath: '/attached_assets/FINAL_DH_Logo_07d76723-4afb-4fda-b328-02af85f82002_1758130723975.avif'
            },
            'stanford-hearing-aids': {
                name: 'Stanford Hearing Aids',
                primaryColor: '#289DA9',  // Teal - main color
                secondaryColor: '#0055A5',  // Blue - secondary elements
                accentColor: '#C84AE1',  // Pink - used sparingly for accents
                textColor: '#2d3748',
                grayLight: '#f7fafc',
                grayMedium: '#e2e8f0',
                grayDark: '#718096',
                shopUrl: 'https://stanfordhearingaids.com/',
                logoPath: '/attached_assets/stanford-hearing-aids-logo_1760037862698.webp',
                isLocalProvider: true,
                phoneNumbers: ['(605) 305-1522', '(763) 285-9200'],
                locations: ['Sioux Falls, SD', 'Madison, SD', 'Buffalo, MN']
            }
        };

        // Get brand from URL parameter
        const urlParams = new URLSearchParams(window.location.search);
        const brandParam = urlParams.get('brand') || 'injoy-hearing';
        const currentBrand = brandConfigs[brandParam] || brandConfigs['injoy-hearing'];

        // Apply brand colors to CSS variables
        const applyBrandColors = () => {
            const root = document.getElementById('hearing-test-root') || document.documentElement;
            root.style.setProperty('--primary-color', currentBrand.primaryColor);
            root.style.setProperty('--secondary-color', currentBrand.secondaryColor);
            root.style.setProperty('--accent-color', currentBrand.accentColor);
            root.style.setProperty('--text-color', currentBrand.textColor);
            root.style.setProperty('--gray-light', currentBrand.grayLight);
            root.style.setProperty('--gray-medium', currentBrand.grayMedium);
            root.style.setProperty('--gray-dark', currentBrand.grayDark);
        };

        // Apply brand colors immediately
        applyBrandColors();

        // Store brand globally for use in other scripts
        window.currentBrand = currentBrand;

        // Configuration and branding - Use global brand configuration
        // urlParams already defined above
        const brand = brandParam; // Use the brand param from above
        const embedMode = urlParams.get('embed') === 'true';

        // --- First-party attribution capture (Shopify-native: reads the real page URL) ---
        const TRACK_KEYS = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','fbclid','msclkid','ttclid'];
        let storedAttribution = {};
        try { storedAttribution = JSON.parse(localStorage.getItem('injoy_attribution') || '{}'); } catch (e) {}
        (function captureAttribution() {
            let changed = false;
            TRACK_KEYS.forEach(function (k) {
                const v = urlParams.get(k);
                if (v) { storedAttribution[k] = v; changed = true; }
            });
            if (changed) {
                storedAttribution._ts = Date.now();
                try { localStorage.setItem('injoy_attribution', JSON.stringify(storedAttribution)); } catch (e) {}
            }
        })();
        function getTracked(key) { return urlParams.get(key) || storedAttribution[key] || ''; }
        function getCookie(name) {
            const m = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]*)'));
            return m ? decodeURIComponent(m[2]) : '';
        }

        
        // Apply brand name to all placeholders and logos
        function applyBrandText() {
            // Update logo
            const logoElem = document.getElementById('brandLogo');
            if (logoElem) {
                // Use the logo path directly
                logoElem.src = (window.HEARING_TEST_CONFIG && window.HEARING_TEST_CONFIG.logoUrl) || window.currentBrand.logoPath;
                logoElem.alt = window.currentBrand.name + ' Hearing Test';
            }
            
            // Update CTA section based on brand type
            const ctaSection = document.getElementById('ctaSection');
            if (ctaSection) {
                if (window.currentBrand.isLocalProvider) {
                    // Stanford Hearing Aids - Local provider with appointment focus
                    ctaSection.innerHTML = `
                        <h3>Schedule Your Professional Hearing Consultation</h3>
                        <p class="cta-text">Visit Stanford Hearing Aids for expert hearing care with Dr. Jain and our professional staff</p>
                        
                        <div style="display: flex; gap: 15px; justify-content: center; flex-wrap: wrap; margin: 20px 0;">
                            <a href="tel:${window.currentBrand.phoneNumbers[0]}" class="btn btn-primary" style="background: var(--accent-color); border-color: var(--accent-color);">
                                📞 Call ${window.currentBrand.phoneNumbers[0]}
                            </a>
                            <a href="${window.currentBrand.shopUrl}" target="_blank" class="btn btn-primary">
                                Schedule Free Consultation
                            </a>
                        </div>
                        
                        <p style="font-size: 14px; color: var(--gray-dark); margin-top: 15px;">
                            <strong>Locations:</strong> ${window.currentBrand.locations.join(' • ')}
                        </p>
                        <p class="trial-text">40+ Years in the Industry • Accepts Most Insurance • Professional Audiologists</p>
                    `;
                } else {
                    // Other brands - Remote/online providers
                    ctaSection.innerHTML = `
                        <h3>Start Your Journey to Better Hearing</h3>
                        <p class="cta-text">Join thousands who have improved their hearing with <span class="brand-name-possessive">${window.currentBrand.name.endsWith('s') ? window.currentBrand.name + '\'' : window.currentBrand.name + '\'s'}</span> remote care model</p>
                        <a href="${window.currentBrand.shopUrl}" target="_blank" class="btn btn-primary">Explore Hearing Aid Options</a>
                        <p class="trial-text">45-Day Risk-Free Trial • Remote Programming • Half the Cost</p>
                    `;
                }
            }
            
            // Update inline brand names
            const inlineElems = document.querySelectorAll('.brand-name-inline');
            inlineElems.forEach(elem => {
                elem.textContent = window.currentBrand.name;
            });
            
            // Update possessive form
            const possessiveElems = document.querySelectorAll('.brand-name-possessive');
            possessiveElems.forEach(elem => {
                elem.textContent = window.currentBrand.name.endsWith('s') ? window.currentBrand.name + '\'' : window.currentBrand.name + '\'s';
            });
        }
        
        // Apply brand text when DOM is ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', applyBrandText);
        } else {
            applyBrandText();
        }
        
        // Apply embed mode styles if needed
        if (embedMode) {
            document.body.classList.add('embed-mode');
            
            // Communicate height to parent frame when in embed mode
            if (window.parent !== window) {
                function sendHeight() {
                    const height = document.documentElement.scrollHeight;
                    window.parent.postMessage({
                        type: 'resize',
                        height: height
                    }, '*');
                }
                
                // Send height on load and after any screen changes
                window.addEventListener('load', sendHeight);
                window.addEventListener('resize', sendHeight);
                
                // Monitor for content changes
                const observer = new MutationObserver(sendHeight);
                observer.observe(document.body, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['class']
                });
                
                // Initial height send
                setTimeout(sendHeight, 100);
                setTimeout(sendHeight, 500);
            }
        }
        
        // Audio context and test variables
        let audioContext;
        let oscillator = null;
        let gainNode = null;
        let isPlaying = false;
        
        // Calibration variables
        let calibrationOscillator = null;
        let calibrationGainNode = null;
        let isCalibrationPlaying = false;
        let currentCalibrationEar = 'both';
        
        const frequencies = [250, 500, 1000, 2000, 4000, 8000];
        const volumeLevels = [-30, -40, -50, -60, -70, -80];
        
        let currentFreqIndex = 0;
        let currentVolumeIndex = 0;
        let currentEar = 'left';
        let results = { left: {}, right: {} };
        let testStartTime = null;
        
        // Initialize audio context on first user interaction
        function initAudio() {
            if (!audioContext) {
                audioContext = new (window.AudioContext || window.webkitAudioContext)();
            }
        }
        
        // Screen management
        function switchScreen(fromId, toId) {
            document.getElementById(fromId).classList.remove('active');
            document.getElementById(toId).classList.add('active');
        }
        
        function showStatus(message) {
            const status = document.getElementById('statusMessage');
            status.textContent = message;
            status.classList.add('show');
            setTimeout(() => status.classList.remove('show'), 2000);
        }
        
        // Phone number formatting
        document.addEventListener('DOMContentLoaded', function() {
            const phoneField = document.getElementById('phone');
            if (phoneField) {
                phoneField.addEventListener('input', function(e) {
                    const cleaned = e.target.value.replace(/\D/g, '');
                    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
                    if (match) {
                        const formatted = [
                            match[1] && '(',
                            match[1],
                            match[1] && match[2] && ') ',
                            match[2],
                            match[2] && match[3] && '-',
                            match[3]
                        ].filter(Boolean).join('');
                        e.target.value = formatted;
                    }
                });
            }
        });
        
        // Calibration functions
        function toggleCalibrationTone() {
            if (isCalibrationPlaying) {
                stopCalibrationTone();
            } else {
                playCalibrationTone(currentCalibrationEar);
            }
        }
        
        function playCalibrationTone(ear = 'both') {
            stopCalibrationTone();
            
            if (!audioContext) {
                initAudio();
            }
            
            calibrationOscillator = audioContext.createOscillator();
            calibrationOscillator.type = 'sine';
            calibrationOscillator.frequency.setValueAtTime(1000, audioContext.currentTime);
            
            calibrationGainNode = audioContext.createGain();
            calibrationGainNode.gain.setValueAtTime(0, audioContext.currentTime);
            // Play at a moderate level for calibration
            calibrationGainNode.gain.linearRampToValueAtTime(Math.pow(10, -40/20), audioContext.currentTime + 0.1);
            
            const panNode = audioContext.createStereoPanner();
            if (ear === 'left') {
                panNode.pan.setValueAtTime(-1, audioContext.currentTime);
            } else if (ear === 'right') {
                panNode.pan.setValueAtTime(1, audioContext.currentTime);
            } else {
                panNode.pan.setValueAtTime(0, audioContext.currentTime);
            }
            
            calibrationOscillator.connect(calibrationGainNode);
            calibrationGainNode.connect(panNode);
            panNode.connect(audioContext.destination);
            
            calibrationOscillator.start();
            isCalibrationPlaying = true;
            currentCalibrationEar = ear;
            
            // Update UI
            const playControl = document.getElementById('calibrationPlayControl');
            playControl.classList.add('playing');
            playControl.textContent = '⏸';
            document.querySelectorAll('#calibrationWave .wave-bar').forEach(bar => bar.classList.add('playing'));
        }
        
        function stopCalibrationTone() {
            if (calibrationOscillator) {
                if (calibrationGainNode) {
                    const currentTime = audioContext.currentTime;
                    calibrationGainNode.gain.cancelScheduledValues(currentTime);
                    calibrationGainNode.gain.setValueAtTime(calibrationGainNode.gain.value, currentTime);
                    calibrationGainNode.gain.linearRampToValueAtTime(0, currentTime + 0.1);
                }
                
                try {
                    calibrationOscillator.stop(audioContext.currentTime + 0.1);
                    calibrationOscillator.disconnect();
                } catch (e) {}
                
                calibrationOscillator = null;
                calibrationGainNode = null;
            }
            
            isCalibrationPlaying = false;
            const playControl = document.getElementById('calibrationPlayControl');
            if (playControl) {
                playControl.classList.remove('playing');
                playControl.textContent = '▶';
            }
            document.querySelectorAll('#calibrationWave .wave-bar').forEach(bar => bar.classList.remove('playing'));
            
            // Reset button states
            document.getElementById('leftEarTestBtn').classList.remove('active');
            document.getElementById('rightEarTestBtn').classList.remove('active');
        }
        
        function testCalibrationEar(ear) {
            // Update button states
            document.getElementById('leftEarTestBtn').classList.remove('active');
            document.getElementById('rightEarTestBtn').classList.remove('active');
            
            if (ear === 'left') {
                document.getElementById('leftEarTestBtn').classList.add('active');
            } else {
                document.getElementById('rightEarTestBtn').classList.add('active');
            }
            
            playCalibrationTone(ear);
            
            // Stop after 2 seconds
            setTimeout(() => {
                stopCalibrationTone();
            }, 2000);
        }
        
        
        // Test functions
        function startTest() {
            initAudio();
            switchScreen('startScreen', 'calibrationScreen');
        }
        
        function startActualTest() {
            stopCalibrationTone();
            results = { left: {}, right: {} };
            currentFreqIndex = 0;
            currentVolumeIndex = 0;
            currentEar = 'left';
            testStartTime = Date.now(); // Track when test starts
            
            switchScreen('calibrationScreen', 'testScreen');
            updateEarIndicator();
            testFrequency();
        }
        
        function updateEarIndicator() {
            const leftBadge = document.getElementById('leftBadge');
            const rightBadge = document.getElementById('rightBadge');
            const earLabel = document.getElementById('earLabel');
            
            if (currentEar === 'left') {
                leftBadge.classList.add('active');
                rightBadge.classList.remove('active');
                earLabel.textContent = 'Testing Left Ear';
            } else {
                leftBadge.classList.remove('active');
                rightBadge.classList.add('active');
                earLabel.textContent = 'Testing Right Ear';
            }
        }
        
        function updateProgressDots() {
            const dots = document.querySelectorAll('.progress-dot');
            dots.forEach((dot, index) => {
                dot.classList.remove('active', 'completed');
                if (index < currentFreqIndex) {
                    dot.classList.add('completed');
                } else if (index === currentFreqIndex) {
                    dot.classList.add('active');
                }
            });
        }
        
        function updateWaveHeight() {
            const currentDb = volumeLevels[currentVolumeIndex];
            const scaleFactor = 0.2 + (0.8 * ((currentDb + 80) / 50));
            const animationSpeed = 1.2 + (1.3 * (1 - scaleFactor));
            const waveBars = document.querySelectorAll('.wave-bar');
            const baseHeights = [40, 60, 80, 100, 90, 75, 60, 50, 40];
            
            waveBars.forEach((bar, index) => {
                bar.style.height = (baseHeights[index] * scaleFactor) + '%';
                bar.style.setProperty('--animation-speed', animationSpeed + 's');
            });
        }
        
        function testFrequency() {
            currentVolumeIndex = 0;
            document.getElementById('currentFreq').textContent = frequencies[currentFreqIndex];
            document.getElementById('progressText').textContent = `Testing frequency ${currentFreqIndex + 1} of ${frequencies.length}`;
            updateProgressDots();
            showStatus('Playing tone - Listen carefully');
            playTone();
        }
        
        function playTone() {
            stopTone();
            
            const frequency = frequencies[currentFreqIndex];
            const volumeDb = volumeLevels[currentVolumeIndex];
            
            oscillator = audioContext.createOscillator();
            oscillator.type = 'sine';
            oscillator.frequency.setValueAtTime(frequency, audioContext.currentTime);
            
            gainNode = audioContext.createGain();
            gainNode.gain.setValueAtTime(0, audioContext.currentTime);
            const targetGain = Math.pow(10, volumeDb / 20);
            gainNode.gain.linearRampToValueAtTime(targetGain, audioContext.currentTime + 0.1);
            
            const panNode = audioContext.createStereoPanner();
            panNode.pan.setValueAtTime(currentEar === 'left' ? -1 : 1, audioContext.currentTime);
            
            oscillator.connect(gainNode);
            gainNode.connect(panNode);
            panNode.connect(audioContext.destination);
            
            oscillator.start();
            isPlaying = true;
            
            const playControl = document.getElementById('playControl');
            playControl.classList.add('playing');
            playControl.textContent = '⏸';
            document.querySelectorAll('.wave-bar').forEach(bar => bar.classList.add('playing'));
            updateWaveHeight();
        }
        
        function stopTone() {
            if (oscillator) {
                if (gainNode) {
                    const currentTime = audioContext.currentTime;
                    gainNode.gain.cancelScheduledValues(currentTime);
                    gainNode.gain.setValueAtTime(gainNode.gain.value, currentTime);
                    gainNode.gain.linearRampToValueAtTime(0, currentTime + 0.1);
                }
                
                try {
                    oscillator.stop(audioContext.currentTime + 0.1);
                    oscillator.disconnect();
                } catch (e) {}
                
                oscillator = null;
                gainNode = null;
            }
            
            isPlaying = false;
            const playControl = document.getElementById('playControl');
            playControl.classList.remove('playing');
            playControl.textContent = '▶';
            document.querySelectorAll('.wave-bar').forEach(bar => bar.classList.remove('playing'));
        }
        
        function togglePlayPause() {
            if (isPlaying) {
                stopTone();
            } else {
                playTone();
            }
        }
        
        function handleResponse(canHear) {
            stopTone();
            
            if (canHear) {
                currentVolumeIndex++;
                if (currentVolumeIndex < volumeLevels.length) {
                    showStatus('Going quieter...');
                    setTimeout(playTone, 800);
                } else {
                    recordThreshold(volumeLevels[volumeLevels.length - 1]);
                }
            } else {
                const threshold = currentVolumeIndex > 0 ? volumeLevels[currentVolumeIndex - 1] : -20;
                recordThreshold(threshold);
            }
        }
        
        function recordThreshold(threshold) {
            results[currentEar][frequencies[currentFreqIndex]] = threshold;
            showStatus(`Threshold found for ${frequencies[currentFreqIndex]} Hz`);
            
            currentFreqIndex++;
            
            if (currentFreqIndex < frequencies.length) {
                setTimeout(testFrequency, 1500);
            } else if (currentEar === 'left') {
                setTimeout(() => switchScreen('testScreen', 'transitionScreen'), 1000);
            } else {
                setTimeout(() => switchScreen('testScreen', 'collectionScreen'), 1000);
            }
        }
        
        function continueToRightEar() {
            currentFreqIndex = 0;
            currentVolumeIndex = 0;
            currentEar = 'right';
            
            switchScreen('transitionScreen', 'testScreen');
            updateEarIndicator();
            updateProgressDots();
            testFrequency();
        }
        
        function calculateHearingLevel(earResults) {
            const thresholds = Object.values(earResults);
            if (thresholds.length === 0) return null;
            
            const average = thresholds.reduce((a, b) => a + b, 0) / thresholds.length;
            
            if (average <= -70) {
                return { 
                    level: 'Normal Hearing',
                    class: 'hearing-normal',
                    description: 'Your hearing is within normal limits across all tested frequencies.'
                };
            } else if (average <= -55) {
                return { 
                    level: 'Mild Hearing Loss',
                    class: 'hearing-mild',
                    description: 'You may notice that soft sounds — like whispered conversations or birds singing — aren\'t as clear as they used to be. You might find yourself asking people to speak up in restaurants or turning the TV volume higher than others prefer. The good news: this level of hearing loss responds very well to modern hearing aids.'
                };
            } else if (average <= -40) {
                return { 
                    level: 'Moderate Hearing Loss',
                    class: 'hearing-moderate',
                    description: 'You\'re likely finding that everyday conversations take more effort, especially when there\'s background noise. Phone calls may be difficult, and you might miss parts of what people say — even when they\'re close by. The good news: hearing aids can make a dramatic difference at this level, bringing back clarity you didn\'t realize you were missing.'
                };
            } else {
                return { 
                    level: 'Significant Hearing Loss',
                    class: 'hearing-severe',
                    description: 'This means you\'re likely missing parts of conversations, struggling to hear in noisy environments, and may find yourself turning up the TV louder than others prefer. The good news — this level of hearing loss is very treatable with modern hearing aids.'
                };
            }
        }
        
        function detectHearingPattern(results) {
            // Check low frequencies (250-500Hz)
            const lowFreqAvg = (results['250'] + results['500']) / 2;
            // Check mid frequencies (1000-2000Hz)
            const midFreqAvg = (results['1000'] + results['2000']) / 2;
            // Check high frequencies (4000-8000Hz)
            const highFreqAvg = (results['4000'] + results['8000']) / 2;
            
            const lowLoss = lowFreqAvg > -55;
            const midLoss = midFreqAvg > -55;
            const highLoss = highFreqAvg > -55;
            
            if (highLoss && !lowLoss && !midLoss) {
                return {
                    pattern: 'High-Frequency Hearing Loss',
                    description: 'Most common type of hearing loss. You may have difficulty hearing consonant sounds like "s", "f", "th", children\'s voices, and birds singing.'
                };
            } else if (lowLoss && !highLoss) {
                return {
                    pattern: 'Low-Frequency Hearing Loss',
                    description: 'Less common pattern. You may struggle with vowel sounds, men\'s voices, and bass tones. Background noise may be particularly challenging.'
                };
            } else if (Math.abs(lowFreqAvg - midFreqAvg) < 15 && Math.abs(midFreqAvg - highFreqAvg) < 15) {
                return {
                    pattern: 'Flat Hearing Loss',
                    description: 'Your hearing loss is relatively equal across all frequencies. This affects your ability to hear all types of sounds equally.'
                };
            } else {
                return {
                    pattern: 'Mixed Pattern Hearing Loss',
                    description: 'Your hearing loss varies across different frequencies. This creates unique challenges depending on the type of sound or environment.'
                };
            }
        }
        
        function generateKeyInsights(hearingLevel, pattern) {
            const insights = [];
            
            if (hearingLevel.level === 'Normal Hearing') {
                insights.push('Your hearing is functioning well across all tested frequencies — great news!');
                insights.push('Regular hearing checkups help catch any future changes early, before they impact your daily life.');
                insights.push('Protecting your hearing in loud environments (concerts, power tools, headphones at high volume) is the best way to maintain your results.');
            } else if (hearingLevel.level === 'Mild Hearing Loss') {
                insights.push(`Your results show a ${pattern.pattern.toLowerCase()} — ${pattern.description.toLowerCase()}`);
                insights.push('At this level, you may not notice hearing loss in quiet settings, but background noise can make conversations challenging. This is one of the most treatable stages.');
                insights.push('A hearing specialist can help you find the right solution — consultations are free and no-obligation.');
            } else if (hearingLevel.level === 'Moderate Hearing Loss') {
                insights.push(`Your hearing pattern shows ${pattern.pattern.toLowerCase()} — ${pattern.description.toLowerCase()}`);
                insights.push('Modern hearing aids can dramatically improve your hearing clarity and quality of life. Many people say they wish they had acted sooner.');
                insights.push('A hearing specialist can help you find the right solution — consultations are free and no-obligation.');
            } else {
                insights.push(`Your hearing pattern shows ${pattern.pattern.toLowerCase()} — this affects your ability to hear voices, music, and environmental sounds.`);
                insights.push('Modern hearing aids can dramatically improve your hearing clarity and quality of life. This level of hearing loss is very treatable with today\'s technology.');
                insights.push('A hearing specialist can help you find the right solution — consultations are free and no-obligation.');
            }
            
            return insights;
        }
        
        function generateBrandSolution(hearingLevel) {
            if (window.currentBrand.isLocalProvider) {
                // Stanford Hearing Aids - local provider content
                if (hearingLevel.level === 'Normal Hearing') {
                    return `
                        <p>Great news! Your hearing is healthy. ${window.currentBrand.name} offers preventive care programs to maintain your hearing health.</p>
                        <ul>
                            <li>Annual hearing evaluations at our offices</li>
                            <li>Hearing protection guidance and custom earplugs</li>
                            <li>Early detection monitoring by experienced audiologists</li>
                        </ul>
                    `;
                } else if (hearingLevel.level === 'Mild Hearing Loss') {
                    return `
                        <p>${window.currentBrand.name}, serving the community since 1983, can help you hear clearly again. Visit one of our three convenient locations in Sioux Falls SD, Madison SD, or Buffalo MN.</p>
                        <ul>
                            <li>Free hearing evaluations by board-certified audiologists</li>
                            <li>Leading brands: Phonak, Starkey, ReSound, Unitron</li>
                            <li>In-person fitting with real-ear measurements</li>
                            <li>Insurance accepted: Blue Cross, Cigna, Aetna, United</li>
                        </ul>
                    `;
                } else {
                    return `
                        <p>${window.currentBrand.name} has been helping people with hearing loss for over 40 years. Visit our offices in Sioux Falls SD, Madison SD, or Buffalo MN for expert care.</p>
                        <ul>
                            <li>Top hearing aid brands with financing available</li>
                            <li>Board-certified audiologists and licensed specialists</li>
                            <li>Comprehensive testing and personalized fitting</li>
                            <li>Lifetime service, cleaning, and adjustments</li>
                        </ul>
                    `;
                }
            } else {
                // Remote providers content (Injoy Hearing, Direct Hearing)
                if (hearingLevel.level === 'Normal Hearing') {
                    return `
                        <p>Great news! Your hearing is healthy. ${window.currentBrand.name} offers preventive care programs to maintain your hearing health through annual remote checkups.</p>
                        <ul>
                            <li>Annual telehealth hearing assessments</li>
                            <li>Hearing protection guidance</li>
                            <li>Early detection monitoring</li>
                        </ul>
                    `;
                } else if (hearingLevel.level === 'Mild Hearing Loss') {
                    return `
                        <p>${window.currentBrand.name}'s discrete, modern hearing aids can help you hear clearly again. Our remote care model makes getting help simple and affordable.</p>
                        <ul>
                            <li>FDA-registered hearing aids delivered in 2-3 days</li>
                            <li>Remote activation with our licensed audiologist</li>
                            <li>Smartphone app for easy adjustments</li>
                            <li>45-day risk-free trial period</li>
                        </ul>
                    `;
                } else {
                    return `
                        <p>${window.currentBrand.name} specializes in helping people with hearing loss through our innovative remote care approach. No waiting rooms, no multiple appointments.</p>
                        <ul>
                            <li>Professional-grade hearing aids at 50% less cost</li>
                            <li>Licensed audiologists provide personalized care</li>
                            <li>Remote programming tailored to your exact needs</li>
                            <li>Ongoing support through our telehealth platform</li>
                        </ul>
                    `;
                }
            }
        }
        
        function generateNextSteps(hearingLevel) {
            const steps = [];
            
            if (window.currentBrand.isLocalProvider) {
                // Stanford Hearing Aids - local provider steps
                if (hearingLevel.level === 'Normal Hearing') {
                    steps.push('Schedule an annual hearing evaluation');
                    steps.push('Protect your hearing in loud environments');
                    steps.push(`Visit ${window.currentBrand.name} for preventive care`);
                } else if (hearingLevel.level === 'Mild Hearing Loss') {
                    steps.push('Call (605) 305-1522 to schedule your free consultation');
                    steps.push('Visit our Sioux Falls, Madison, or Buffalo location');
                    steps.push('Get a comprehensive evaluation by board-certified audiologists');
                    steps.push('Try the latest Phonak, Starkey, or ReSound technology');
                } else {
                    steps.push('Call (605) 305-1522 today for immediate appointment');
                    steps.push('Visit our nearest location for comprehensive testing');
                    steps.push('Work with audiologists to select the best hearing aids');
                    steps.push('Enjoy lifetime service and support at all three locations');
                }
            } else {
                // Remote providers steps (Injoy Hearing, Direct Hearing)
                if (hearingLevel.level === 'Normal Hearing') {
                    steps.push('Annual hearing check recommended to maintain hearing health');
                    steps.push('Protect your hearing in loud environments');
                    steps.push(`Consider ${window.currentBrand.name}'s preventive hearing care program`);
                } else if (hearingLevel.level === 'Mild Hearing Loss') {
                    steps.push('Schedule a free remote consultation with our audiologist');
                    steps.push(`Try ${window.currentBrand.name} hearing aids risk-free for 45 days`);
                    steps.push('Experience remote programming from your home');
                } else {
                    steps.push('Connect with our audiologist via telehealth today');
                    steps.push('Get hearing aids delivered in 2-3 days');
                    steps.push('Receive remote activation and personalized fitting');
                    steps.push('Save 50% compared to traditional clinics');
                }
            }
            
            return steps;
        }
        
        function generateWhyBrand(hearingLevel) {
            const items = [];
            
            if (window.currentBrand.isLocalProvider) {
                if (hearingLevel.level === 'Normal Hearing') {
                    items.push({ icon: '🩺', title: 'Annual Hearing Evaluations', text: 'Professional checkups at our offices to monitor your hearing health.' });
                    items.push({ icon: '🔇', title: 'Hearing Protection', text: 'Custom earplugs and guidance to prevent future hearing loss.' });
                    items.push({ icon: '👨‍⚕️', title: 'Experienced Professionals', text: 'Board-certified audiologists with 40+ years in the industry.' });
                    items.push({ icon: '📍', title: 'Convenient Locations', text: window.currentBrand.locations.join(' • ') });
                } else {
                    items.push({ icon: '🆓', title: 'Free Hearing Evaluations', text: 'Comprehensive testing by board-certified audiologists at no cost.' });
                    items.push({ icon: '🏆', title: 'Leading Hearing Aid Brands', text: 'Phonak, Starkey, ReSound, Unitron — expertly fitted to your needs.' });
                    items.push({ icon: '🏥', title: '40+ Years of Expert Care', text: 'Board-certified audiologists and licensed specialists serving the community since 1983.' });
                    items.push({ icon: '💳', title: 'Insurance & Financing', text: 'Accepts Blue Cross, Cigna, Aetna, United. Financing available.' });
                    items.push({ icon: '🔧', title: 'Lifetime Service & Support', text: 'Ongoing adjustments, cleaning, and care at all three locations.' });
                }
            } else {
                if (hearingLevel.level === 'Normal Hearing') {
                    items.push({ icon: '🩺', title: 'Annual Remote Checkups', text: 'Telehealth hearing assessments from the comfort of your home.' });
                    items.push({ icon: '🔇', title: 'Hearing Protection Guidance', text: 'Expert advice on protecting your hearing in loud environments.' });
                    items.push({ icon: '📊', title: 'Early Detection Monitoring', text: 'Catch any changes early before they impact your daily life.' });
                } else {
                    items.push({ icon: '👨‍⚕️', title: 'Licensed Audiologists', text: 'Remote activation and personalized programming by licensed professionals.' });
                    items.push({ icon: '🔄', title: '45-Day Risk-Free Trial', text: 'Try your hearing aids with confidence — full refund if you\'re not satisfied.' });
                    items.push({ icon: '💰', title: 'Save 50% vs. Clinics', text: 'Professional-grade hearing aids at half the cost of traditional providers.' });
                    items.push({ icon: '📱', title: 'Easy Remote Adjustments', text: 'Fine-tune your hearing aids from your smartphone — no office visits needed.' });
                }
            }
            
            return items;
        }

        function submitData(event) {
            event.preventDefault();
            
            // Validate all required fields including consent
            const firstName = document.getElementById('firstName').value;
            const lastName = document.getElementById('lastName').value;
            const email = document.getElementById('email').value;
            const phone = document.getElementById('phone').value;
            const consent = document.getElementById('consent').checked;
            
            if (!firstName || !lastName || !email || !phone || !consent) {
                alert('Please fill in all required fields and agree to the consent to see your results.');
                return;
            }
            
            switchScreen('collectionScreen', 'loadingScreen');
            
            // Prepare data
            const formData = {
                firstName: firstName,
                lastName: lastName,
                email: email,
                phone: phone,
                consent_to_contact: consent,
                brand: window.currentBrand.name,
                page_url: embedMode ? document.referrer : window.location.href,
                utmSource: getTracked('utm_source'),
                utmMedium: getTracked('utm_medium'),
                utmCampaign: getTracked('utm_campaign'),
                utm_term: getTracked('utm_term'),
                utm_content: getTracked('utm_content'),
                gclid: getTracked('gclid'),
                fbclid: getTracked('fbclid'),
                msclkid: getTracked('msclkid'),
                ttclid: getTracked('ttclid'),
                hearing_test_results: results,
                brandKey: brand,
                test_date: new Date().toISOString()
            };
            
            // Calculate test duration
            const testDuration = Math.floor((Date.now() - testStartTime) / 1000);
            
            // Prepare data for our backend with additional tracking
            const backendData = {
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: formData.email,
                phone: formData.phone,
                consent: formData.consent_to_contact,
                leftEar: results.left,
                rightEar: results.right,
                utmSource: formData.utmSource,
                utmMedium: formData.utmMedium,
                utmCampaign: formData.utmCampaign,
                utmTerm: formData.utm_term,
                utmContent: formData.utm_content,
                gclid: formData.gclid,
                fbclid: formData.fbclid,
                msclkid: formData.msclkid,
                ttclid: formData.ttclid,
                userAgent: navigator.userAgent,
                testDuration: testDuration,
                sourceUrl: window.location.href,
                referrerUrl: document.referrer || 'direct',
                screenWidth: window.screen.width,
                screenHeight: window.screen.height,
                language: navigator.language || navigator.userLanguage,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                brand: window.currentBrand.name,
                brandKey: brand
            };
            
            // Submit directly to HubSpot and (during transition) to the legacy Replit backend
            const submissions = [submitToHubSpot(backendData)];
            const legacyBackend = ((window.HEARING_TEST_CONFIG && window.HEARING_TEST_CONFIG.backendUrl) || '').replace(/\/+$/, '');
            if (legacyBackend) {
                submissions.push(
                    fetch(legacyBackend + '/api/save-test', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(backendData)
                    })
                    .then(response => response.json())
                    .then(data => { console.log('Legacy backend saved:', data && data.success, data && data.testId); return data; })
                    .catch(error => { console.error('Legacy backend error:', error); })
                );
            }
            const submitTimeout = new Promise(resolve => setTimeout(resolve, 12000));
            Promise.race([Promise.allSettled(submissions), submitTimeout]).then(() => showResults());
        }
        
        function buildResultsSummary(data) {
            try {
                const freqs = [250, 500, 1000, 2000, 4000, 8000];
                const fmt = ear => freqs.map(f => f + 'Hz:' + ear[f] + 'dB').join(', ');
                return 'Test ' + new Date().toISOString().slice(0, 10)
                    + ' | Left: ' + fmt(data.leftEar)
                    + ' | Right: ' + fmt(data.rightEar)
                    + ' | Duration: ' + data.testDuration + 's';
            } catch (e) {
                return 'Hearing test completed ' + new Date().toISOString();
            }
        }

        function submitToHubSpot(data) {
            const cfg = window.HEARING_TEST_CONFIG || {};
            if (!cfg.hubspotPortalId || !cfg.hubspotFormGuid) {
                console.warn('HubSpot form GUID not configured in section settings; skipping HubSpot submission.');
                return Promise.resolve({ skipped: true });
            }
            const endpoint = 'https://api.hsforms.com/submissions/v3/integration/submit/'
                + cfg.hubspotPortalId + '/' + cfg.hubspotFormGuid;
            const freqs = [250, 500, 1000, 2000, 4000, 8000];
            let fields = [
                { name: 'firstname', value: data.firstName },
                { name: 'lastname', value: data.lastName },
                { name: 'email', value: data.email },
                { name: 'phone', value: data.phone },
                { name: 'gclid', value: data.gclid },
                { name: 'utm_source', value: data.utmSource },
                { name: 'utm_medium', value: data.utmMedium },
                { name: 'utm_campaign', value: data.utmCampaign },
                { name: 'online_hearing_test', value: 'Yes' },
                { name: 'recent_hearing_test', value: buildResultsSummary(data) }
            ];
            freqs.forEach(function (f) {
                if (data.leftEar && data.leftEar[f] !== undefined) fields.push({ name: 'left_ear_' + f + 'hz_frequency', value: String(data.leftEar[f]) });
                if (data.rightEar && data.rightEar[f] !== undefined) fields.push({ name: 'right_ear_' + f + 'hz_frequency', value: String(data.rightEar[f]) });
            });
            fields = fields.filter(function (f) {
                return f.value !== undefined && f.value !== null && f.value !== '' && f.value !== 'undefined' && f.value !== 'NaN';
            });
            const context = { pageUri: window.location.href, pageName: document.title };
            const hutk = getCookie('hubspotutk');
            if (hutk) context.hutk = hutk;
            const payload = { fields: fields, context: context };
            if (data.consent) {
                payload.legalConsentOptions = {
                    consent: {
                        consentToProcess: true,
                        text: 'I agree to be contacted about my hearing test results and hearing care options.'
                    }
                };
            }
            function post(body) {
                return fetch(endpoint, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body)
                });
            }
            return post(payload).then(function (r) {
                if (r.ok) { console.log('HubSpot submission OK'); return r.json().catch(function () { return {}; }); }
                return r.text().then(function (t) {
                    console.error('HubSpot submission failed (' + r.status + '):', t);
                    if (r.status !== 400) return { error: true };
                    // Retry with core contact fields only, in case optional fields are missing from the form
                    const core = ['firstname', 'lastname', 'email', 'phone'];
                    const coreFields = fields.filter(function (f) { return core.indexOf(f.name) !== -1; });
                    return post({ fields: coreFields, context: context }).then(function (r2) {
                        console.log('HubSpot core-fields retry status: ' + r2.status);
                        return r2.json().catch(function () { return {}; });
                    });
                });
            }).catch(function (e) {
                console.error('HubSpot submission error:', e);
                return { error: true };
            });
        }

        function showResults() {
            document.querySelector('.app-container').classList.add('results-active');
            document.body.classList.add('results-body-padding');
            
            switchScreen('loadingScreen', 'resultsScreen');
            
            applyBrandText();
            
            const combinedResults = {};
            frequencies.forEach(freq => {
                combinedResults[freq] = (results.left[freq] + results.right[freq]) / 2;
            });
            
            const hearingLevel = calculateHearingLevel(combinedResults);
            const pattern = detectHearingPattern(combinedResults);
            
            const levelEmoji = hearingLevel.level === 'Normal Hearing' ? '🎉' : 
                               hearingLevel.level === 'Mild Hearing Loss' ? '📊' : 
                               hearingLevel.level === 'Moderate Hearing Loss' ? '📋' : '⚠️';
            
            document.getElementById('overallHearingLevel').innerHTML = `
                <h2>Your Hearing Assessment</h2>
                <div class="hearing-level">${levelEmoji} ${hearingLevel.level}</div>
                <div class="hearing-level-description">${hearingLevel.description}</div>
            `;
            
            // Highlight severity scale
            document.querySelectorAll('.severity-segment').forEach(seg => {
                seg.classList.remove('active');
                if (seg.dataset.level === hearingLevel.level) {
                    seg.classList.add('active');
                }
            });
            
            // Ear results
            const leftLevel = calculateHearingLevel(results.left);
            const rightLevel = calculateHearingLevel(results.right);
            
            document.getElementById('leftEarSummary').className = leftLevel.class;
            document.getElementById('leftEarSummary').textContent = leftLevel.level;
            
            document.getElementById('rightEarSummary').className = rightLevel.class;
            document.getElementById('rightEarSummary').textContent = rightLevel.level;
            
            // Ear comparison note
            const earNote = document.getElementById('earComparisonNote');
            if (leftLevel.level === rightLevel.level) {
                earNote.textContent = 'Both ears are showing similar results, which is common. This means both ears would benefit equally from treatment.';
            } else {
                earNote.textContent = `Your left and right ears are showing different levels (${leftLevel.level} vs ${rightLevel.level}). This is not unusual — a hearing specialist can address both ears with personalized solutions.`;
            }
            
            // Key insights
            const insights = generateKeyInsights(hearingLevel, pattern);
            const insightsHTML = insights.map(insight => `<li>${insight}</li>`).join('');
            document.getElementById('keyInsights').innerHTML = `<ul>${insightsHTML}</ul>`;
            
            // CTA results tie-back
            const ctaResultsTie = document.getElementById('ctaResultsTie');
            if (hearingLevel.level === 'Normal Hearing') {
                ctaResultsTie.textContent = 'Your hearing looks great! A specialist can help you develop a plan to keep it that way.';
            } else {
                ctaResultsTie.textContent = 'Based on your results, speaking with a licensed audiologist is the recommended next step.';
            }
            
            // Why Brand section
            const whyItems = generateWhyBrand(hearingLevel);
            const whyGrid = document.getElementById('whyBrandGrid');
            whyGrid.innerHTML = whyItems.map(item => `
                <div class="why-brand-item">
                    <span class="why-brand-icon">${item.icon}</span>
                    <div>
                        <strong>${item.title}</strong>
                        <p>${item.text}</p>
                    </div>
                </div>
            `).join('');
            
            // Final CTA section
            const ctaSection = document.getElementById('ctaSection');
            if (window.currentBrand.isLocalProvider) {
                ctaSection.innerHTML = `
                    <h3>Ready to Hear Better? Let's Get Started.</h3>
                    <p class="cta-text">Based on your hearing assessment, a free consultation is the recommended next step. Our specialists will review your results and help you find the right solution.</p>
                    <a href="#ctaScheduleSection" class="btn btn-primary" onclick="document.getElementById('ctaScheduleSection').scrollIntoView({behavior:'smooth'});return false;">Schedule Your Free Consultation</a>
                    <div style="margin-top: 15px;">
                        <a href="tel:${window.currentBrand.phoneNumbers[0]}" class="btn-outline-secondary">📞 Call ${window.currentBrand.phoneNumbers[0]}</a>
                    </div>
                    <p class="cta-phone-note">Or call ${window.currentBrand.phoneNumbers[0]} to discuss your results with a specialist</p>
                    <p style="font-size: 14px; color: var(--gray-dark); margin-top: 15px;">
                        <strong>Locations:</strong> ${window.currentBrand.locations.join(' • ')}
                    </p>
                `;
            } else {
                ctaSection.innerHTML = `
                    <h3>Ready to Hear Better? Let's Get Started.</h3>
                    <p class="cta-text">Based on your hearing assessment, a free consultation is the recommended next step. Our specialists will review your results and help you find the right solution.</p>
                    <a href="#ctaScheduleSection" class="btn btn-primary" onclick="document.getElementById('ctaScheduleSection').scrollIntoView({behavior:'smooth'});return false;">Schedule Your Free Consultation</a>
                    <div style="margin-top: 15px;">
                        <a href="${window.currentBrand.shopUrl}" target="_blank" class="btn-outline-secondary">Explore Hearing Aid Options</a>
                    </div>
                    <p class="cta-phone-note">Or call <a href="tel:8448200630">(844) 820-0630</a> to discuss your results with a specialist</p>
                `;
            }
            
            // Warning/disclaimer
            const warningSection = document.getElementById('resultsWarning');
            if (window.currentBrand.isLocalProvider) {
                warningSection.innerHTML = `This screening is provided by ${window.currentBrand.name}. Our licensed audiologists can provide a comprehensive evaluation and personalized hearing solutions at our three convenient locations. Call ${window.currentBrand.phoneNumbers[0]} for more information.`;
            } else {
                warningSection.innerHTML = `This screening is provided by ${window.currentBrand.name}. Our licensed audiologists can provide a comprehensive remote evaluation and personalized hearing solutions. Call <a href="tel:8448200630" style="color: var(--primary-color); font-weight: 600;">(844) 820-0630</a> for more information.`;
            }
            
            // Sticky desktop header
            const stickyLogo = document.getElementById('stickyBrandLogo');
            if (stickyLogo) {
                stickyLogo.src = window.currentBrand.logoPath;
            }
            document.getElementById('stickyResultText').textContent = `Your result: ${hearingLevel.level}`;
            
            // Show sticky mobile bar
            const mobileBar = document.getElementById('stickyMobileBar');
            if (mobileBar) mobileBar.classList.add('visible');
            
            // Load HubSpot Meetings embed script
            loadHubSpotMeetings();
        }
        
        function loadHubSpotMeetings() {
            const container = document.querySelector('#ctaScheduleSection .meetings-iframe-container');
            if (!container) return;
            
            // Reset container for fresh embed
            const dataSrc = container.getAttribute('data-src');
            container.innerHTML = '';
            container.setAttribute('data-src', dataSrc);
            
            // Remove old script if present so it re-initializes
            const oldScript = document.querySelector('script[src*="MeetingsEmbedCode"]');
            if (oldScript) oldScript.remove();
            
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
            document.body.appendChild(script);
        }
        
        function resetTest() {
            document.querySelector('.app-container').classList.remove('results-active');
            document.body.classList.remove('results-body-padding');
            const mobileBar = document.getElementById('stickyMobileBar');
            if (mobileBar) mobileBar.classList.remove('visible');
            stopTone();
            currentFreqIndex = 0;
            currentVolumeIndex = 0;
            currentEar = 'left';
            results = { left: {}, right: {} };
            
            document.querySelectorAll('.screen').forEach(screen => screen.classList.remove('active'));
            document.getElementById('startScreen').classList.add('active');
        }